// @flow
import styled from 'styled-components'
import { Card } from 'antd'

export const StyledCard = styled(Card) `
  .ant-card-head-title {
    p {
      margin: 0;  
      span { 
        font-size: 10px;
        float: right;            
      } 
    }
   }
   .postView {
    img {
      max-width: 100%;
    }
   }
`




// WEBPACK FOOTER //
// ./src/components/categories/style.js